import React, { useState, useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import ReferenciaOnline from "../utilities/ReferenciaOnline";
import generarLineaCaptura from "../utilities/GenerarLineaCaptura"; 

import "./Formulario.css";
import { plantelDeMatricula } from "../utilities/plantel";

const Formulario = ({
  conceptos,
  alumno,
  precio,
  cambiarPrecio,
  datospago,
  cambiarDatosPago,
  claves,
  cambiarClaves,
  checked,
  cambiarChecked,
  cambiarPagar = () => {},
  pagar,
  cambiarTablaConceptos,
  tablaConceptos,
}) => {
  const history = useHistory();
  
  const [error, cambiarError] = useState(false);
  const [mensajeError, cambiarMensajeError] = useState("");
  const [seleccionados, cambiarSeleccionados] = useState(0);

  useEffect(() => {
    cambiarPagar(false);
    cambiarPrecio(0);
    cambiarTablaConceptos([]);
    cambiarClaves([]);
    cambiarChecked({}); 
  }, [cambiarPagar, cambiarPrecio, cambiarTablaConceptos, cambiarClaves, cambiarChecked]);

  useEffect(() => {
    if (seleccionados > 0 && seleccionados < 5) {
      cambiarError(false);
    }
  }, [seleccionados]);

  const removeItemFromArr = (arr, item) => {
    return arr.filter((e) => e !== item);
  };

  const removeItemFromObjArr = (arr, item) => {
    return arr.filter((e) => e.clave !== item);
  };

  const onCLickCheck = (concepto) => {
    if (concepto.checked) {
      // Desmarcar
      cambiarChecked({ ...checked, [concepto.id]: false });
      cambiarPrecio(precio - concepto.precio);
      cambiarSeleccionados(seleccionados - 1);
      cambiarClaves(removeItemFromArr(claves, concepto.clave));
      cambiarTablaConceptos(
        removeItemFromObjArr(tablaConceptos, concepto.clave)
      );
    } else {
      // Marcar (Verificando límite de 5)
      if (seleccionados >= 5) {
        cambiarMensajeError("Límite alcanzado.");
        cambiarError(true);
        return;
      }
      
      cambiarChecked({ ...checked, [concepto.id]: true });
      cambiarPrecio(precio + concepto.precio);
      cambiarSeleccionados(seleccionados + 1);
      cambiarClaves([...claves, concepto.clave]);
      
      cambiarTablaConceptos([
        ...tablaConceptos,
        {
          concepto: concepto.concepto,
          clave: concepto.clave,
          precio: concepto.precio.toString(),
        },
      ]);
    }
  };

const HandleSubmit = async (e) => {
    e.preventDefault();

    if (claves.length === 0) {
      cambiarMensajeError("⚠️ Selecciona al menos un concepto para continuar.");
      cambiarError(true);
      return;
    }

    cambiarError(false);

    let importe = precio.toString().concat(".00");
    const matriculaStr = String(alumno.codigo);
    
    // Calculamos el plantel con las reglas exactas
    const plantelOficialAlumno = plantelDeMatricula(matriculaStr);

    // 1. Generamos TODAS las referencias (El Centro de Mando)
    const datosReferencia = generarLineaCaptura(plantelOficialAlumno, claves, matriculaStr, precio);
    
    // 2. Extraemos la de Banorte para mandarla a tu sistema viejo (Adquira)
    // SOLUCIÓN AL ERROR: Aquí agregamos el ".banorte"
    const lineaCapturaFinal = datosReferencia.banorte.lineaDeCaptura;

    // Enviamos la referencia M97 al banco para encriptar en Base64
    let base64 = await ReferenciaOnline(lineaCapturaFinal, importe);

    // 3. Avanzamos a la siguiente pantalla con los datos actualizados
    // MEJORA: Mandamos todo el objeto "datosReferencia" para que el PDF tenga acceso a Bancomer
    cambiarDatosPago({
      referencia: lineaCapturaFinal,       // Línea Banorte (para retrocompatibilidad)
      referenciaBBVA: datosReferencia.bancomer.lineaDeCaptura, // Línea Bancomer
      importe: importe,
      key: base64,
      detallesCompletos: datosReferencia   // Todo el paquete crudo por si lo necesitas
    });

    cambiarPagar(true);
    history.push("/formadepago");
  };

  const mitad = Math.ceil(conceptos.length / 2);
  const conceptosColumna1 = conceptos.slice(0, mitad);
  const conceptosColumna2 = conceptos.slice(mitad);

  return alumno.codigo === "" ? (
    <Redirect to="/login" />
  ) : (
    <div className="Formulario-container container">
      <button 
        className="Formulario-btn-regresar" 
        onClick={() => history.push("/tipo")}
      >
        &#8592; Regresar
      </button>

      <div className="Formulario-card">
        <h3>Conceptos Generales <span>Máximo 5 permitidos</span></h3>
        <p>Selecciona los conceptos que deseas pagar de la siguiente lista marcando la casilla correspondiente a la derecha. El total se calculará automáticamente.</p>
      </div>

      <form onSubmit={HandleSubmit}>
        <div className="Formulario-flex">
          <div className="Formulario-table-wrapper">
            <div className="Formulario-tables-grid">
              
              <table className="Formulario-table">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th className="th-center">Costo</th>
                    <th className="th-center">Seleccionar</th>
                  </tr>
                </thead>
                <tbody>
                  {conceptosColumna1.map((concepto, index) => (
                    <tr key={concepto.clave} className={index % 2 !== 0 ? "Formulario-par" : ""}>
                      <td className="Formulario-concepto">{concepto.concepto}</td>
                      <td className="td-center">${Number(concepto.precio).toFixed(2)}</td>
                      <td className="td-center">
                        <input
                          type="checkbox"
                          id={concepto.id}
                          checked={concepto.checked}
                          onChange={() => onCLickCheck(concepto)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <table className="Formulario-table Formulario-table-right">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th className="th-center">Costo</th>
                    <th className="th-center">Seleccionar</th>
                  </tr>
                </thead>
                <tbody>
                  {conceptosColumna2.map((concepto, index) => (
                    <tr key={concepto.clave} className={index % 2 !== 0 ? "Formulario-par" : ""}>
                      <td className="Formulario-concepto">{concepto.concepto}</td>
                      <td className="td-center">${Number(concepto.precio).toFixed(2)}</td>
                      <td className="td-center">
                        <input
                          type="checkbox"
                          id={concepto.id}
                          checked={concepto.checked}
                          onChange={() => onCLickCheck(concepto)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>

          <div className="Formulario-paybox">
            <div className="Formulario-total">
              <h4>Total: <span>${Number(precio).toFixed(2)}</span></h4>
            </div>
            
            {error ? (
              <div className="Formulario-error">
                <p>{mensajeError}</p>
              </div>
            ) : null}
            
            <input 
              className="Formulario-boton" 
              type="submit" 
              value="CONTINUAR"
            />
          </div>
          
        </div>
      </form>
    </div>
  );
};

export default Formulario;